// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * Invalid input data error (400)
 * The error information
 */
export const zErrorBadRequest = z.object({
    message: z.string(),
    code: z.string(),
    issues: z.array(z.object({
        message: z.string()
    })).optional()
});

/**
 * Authorization not provided error (401)
 * The error information
 */
export const zErrorUnauthorized = z.object({
    message: z.string(),
    code: z.string(),
    issues: z.array(z.object({
        message: z.string()
    })).optional()
});

/**
 * Insufficient access error (403)
 * The error information
 */
export const zErrorForbidden = z.object({
    message: z.string(),
    code: z.string(),
    issues: z.array(z.object({
        message: z.string()
    })).optional()
});

/**
 * Internal server error error (500)
 * The error information
 */
export const zErrorInternalServerError = z.object({
    message: z.string(),
    code: z.string(),
    issues: z.array(z.object({
        message: z.string()
    })).optional()
});

/**
 * Not found error (404)
 * The error information
 */
export const zErrorNotFound = z.object({
    message: z.string(),
    code: z.string(),
    issues: z.array(z.object({
        message: z.string()
    })).optional()
});

export const zExposedPostCommentData = z.object({
    body: z.object({
        responder: z.object({
            id: z.string(),
            name: z.string().min(1).max(50)
        }),
        origin: z.object({
            id: z.string(),
            type: z.enum([
                'mako_article'
            ]),
            url: z.string().url()
        }),
        parentId: z.string().optional(),
        content: z.string().min(1).max(500)
    }),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zExposedGetCommentsData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        originId: z.string(),
        parentId: z.string().optional(),
        limit: z.number().gte(20).lte(50),
        cursor: z.string().optional()
    })
});

/**
 * Successful response
 */
export const zExposedGetCommentsResponse = z.object({
    comments: z.array(z.object({
        id: z.string(),
        content: z.string(),
        parent_id: z.union([
            z.string(),
            z.null()
        ]),
        status: z.enum([
            'approved',
            'rejected',
            'pending'
        ]),
        created_at: z.string(),
        depth: z.number(),
        root_id: z.string(),
        root_created_at: z.string(),
        responder_name: z.string(),
        replies_count: z.number()
    })),
    cursor: z.string().optional()
});

export const zExposedGetOriginCommentsCountData = z.object({
    body: z.never().optional(),
    path: z.object({
        originId: z.string()
    }),
    query: z.never().optional()
});

/**
 * Successful response
 */
export const zExposedGetOriginCommentsCountResponse = z.object({
    count: z.number()
});